import { DatabaseFile } from '../models/classes/files/File';
import { FileType } from '../models/classes/files/FileType.enum';
import { __ } from './object.functions';

export class FileVariationHelper {
  static getSrc(file: DatabaseFile, variationfilterValue: string = ''): string {
    let src = null;

    if (__.IsNullOrUndefined(file)) {
      return null;
    }

    if (__.IsNullOrUndefined(file?.variations)) {
      return `${file.url}/MD`
    }

    switch (file?.fileType) {
      case FileType.Image:
        src = file?.variations.find(q => q.name === variationfilterValue)?.url ?? file?.variations.find(q => q.name === 'Original')?.url;
        break;
      case FileType.Audio:
        src = file?.variations.find(q => q.contentType === variationfilterValue)?.url ?? file?.variations.find(q => q.contentType === 'audio/wav')?.url;
        break;
      case FileType.Video:
        src = file?.variations.find(q => q.contentType === variationfilterValue)?.url ?? file?.variations.find(q => q.contentType === 'video/mp4')?.url;
        break;
    }

    return src;
  }
}
